import { startWith, switchMap, map, catchError } from "rxjs/operators";
import { ViewItemDetailComponent } from "./view-item-detail/view-item-detail.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params } from "@angular/router";
import { MatTableDataSource } from "@angular/material/table";
import { MatSort } from "@angular/material/sort";
import { MatPaginator } from "@angular/material/paginator";
import { FondsPropresService } from "../../services/fonds-propres.service";
import { ImportPortefeuilleDetail } from "../../models/ImportPortefeuilleDetail";
import { ImportPortefeuille } from "../../models/ImportPortefeuille";
import { Component, OnInit, ViewChild, AfterViewInit } from "@angular/core";
import { merge, Observable, of as observableOf } from "rxjs";

@Component({
  selector: "app-importation-details",
  templateUrl: "./importation-details.component.html",
  styleUrls: ["./importation-details.component.scss"],
})
export class ImportationDetailsComponent implements OnInit, AfterViewInit {
  @ViewChild(MatPaginator, { static: false })
  paginator: MatPaginator;
  @ViewChild(MatSort, { static: false })
  sort: MatSort;
  //dataSource: MatTableDataSource<ImportPortefeuilleDetail> = new MatTableDataSource();
  dataSource: ImportPortefeuilleDetail[];
  isLoadingResults = true;

  resultsLength = 0;
  isRateLimitReached = false;

  displayedColumns = [
    "codeDossier",
    "nomClient",
    "libelleSegmentPrudentiel",
    "creanceSaine",
    "creanceEnSouffrance",
    "provision",
    "montantPretRestant",
    "montantEngagementHorsBilan",
    "nombreGarantie",
    "cumulActifPondereRisque",
    "fondPropreAssocie",
    "actions",
  ];
  data: ImportPortefeuilleDetail[] = [];
  importPortefeuilleId: number;
  importPortefeuille: ImportPortefeuille;

  constructor(
    private shared: FondsPropresService,
    private _activatedRoute: ActivatedRoute,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this._activatedRoute.params.subscribe((params: Params) => {
      this.importPortefeuilleId = params["importPortefeuilleId"];
      this.getImportPortefeuille(this.importPortefeuilleId);
      //this.getImportPortefeuilleDetails(this.importPortefeuilleId);
    });
  }

  ngAfterViewInit() {
    this.getImportPortefeuilleDetails(this.importPortefeuilleId, "_", 0);
  }

  getImportPortefeuille(importPortefeuilleId: number) {
    this.shared.getImportPortefeuille(importPortefeuilleId).subscribe(
      (data) => {
        this.importPortefeuille = data;
      },
      (error) => {
        console.log(error);
      },
      () => {}
    );
  }

  //View row in modal popup
  ViewImportPortefeuilleDetail(row) {
    const modalRef = this.modalService.open(ViewItemDetailComponent, {
      centered: true,
      backdropClass: "light-blue-backdrop",
      backdrop: "static",
      scrollable: true,
      windowClass: "my-app-modal-class",
    });
    modalRef.componentInstance.portefeuilleDetail = row;
    modalRef.componentInstance.importPortefeuilleId = this.importPortefeuilleId;

    modalRef.result.then(
      (result) => {
        console.log("result", result);
        // on close
        //this.getImportPortefeuilleDetails(this.importPortefeuilleId);
      },
      (reason) => {
        console.log("reason", reason);
        // on dismiss
      }
    );
  }

  getImportPortefeuilleDetails(
    importPortefeuilleId: number,
    filter: String,
    pageIndex: number
  ): void {
    // If the user changes the sort order, reset back to the first page.
    this.sort.sortChange.subscribe(
      () => (this.paginator.pageIndex = pageIndex)
    );

    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;

          return this.shared.getImportPortefeuilleDetails(
            importPortefeuilleId,
            filter,
            this.paginator.pageIndex,
            this.paginator.pageSize,
            this.sort.active,
            this.sort.direction
          );
        }),
        map((data) => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsLength = data.totalElements;

          return data.content;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          // Catch if the GitHub API has reached its rate limit. Return empty data.
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      )
      .subscribe((data) => (this.dataSource = data));
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.getImportPortefeuilleDetails(
      this.importPortefeuilleId,
      filterValue.trim().toLowerCase(),
      0
    );
    //this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  valuechange(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    if (filterValue.trim() == "" || filterValue.trim() == null) {
      this.getImportPortefeuilleDetails(this.importPortefeuilleId, "_", 0);
    }
  }
}
